import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

const SupplyChainCaseStudies = () => {
    return (
        <div className="section-py">
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12 mb-10">
                    <div className="lg:col-span-12">
                        <h2 className="text-primary_one mb-3">Case Studies</h2>
                        <p className="mb-0">
                            We don&apos;t just promise outcomes, we build them. See how our custom supply chain software
                            development solutions are solving real-world challenges for businesses like yours.
                        </p>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12 mb-10">
                    <div className="lg:col-span-12">
                        <div className="border rounded-10 bg-grey lg:p-10 md:p-10 p-4 flex lg:flex-nowrap md:flex-nowrap flex-wrap gap-7 lg:gap-0 md:gap-0">
                            <div className="lg:pr-7 md:pr-7 pr-0">
                                <p className="font-semibold text-primary_one mb-3">Cut Inventory Costs by</p>
                                <div className="flex items-center mb-3">
                                    <div className="pr-2">
                                        <Image
                                            src="/img/icons/ic-cost-delay.svg"
                                            alt="Cut Inventory Costs"
                                            title="Cut Inventory Costs"
                                            height={40}
                                            width={40}
                                        />
                                    </div>
                                    <p className="fs-xxl font-bold mb-0 text-primary_one">37%</p>
                                </div>
                                <p className="fs-md mb-0">
                                    A leading healthcare distributor struggled with excess stock and outdated forecasting. We
                                    built an AI-powered inventory management system that slashed holding costs while improving
                                    on-time availability across all regions.
                                </p>
                            </div>
                            <div className="pr-0 pl-0 lg:pr-7 md:pr-7 lg:pl-7 md:pl-7 border-r-0 border-l-0 lg:border-r lg:border-l md:border-r md:border-l">
                                <p className="font-semibold text-primary_one mb-3">Reduced Delivery Delays by</p>
                                <div className="flex items-center mb-3">
                                    <div className="pr-2">
                                        <Image
                                            src="/img/icons/ic-cost-delay.svg"
                                            alt="Reduced Delivery Delays"
                                            title="Reduced Delivery Delays"
                                            height={40}
                                            width={40}
                                        />
                                    </div>
                                    <p className="fs-xxl font-bold mb-0 text-primary_one">60%</p>
                                </div>
                                <p className="fs-md mb-0">
                                    A global logistics company faced constant route inefficiencies. Our AI-driven fleet management
                                    platform optimized routing in real time—cutting delays, fuel waste, and operational
                                    bottlenecks.
                                </p>
                            </div>
                            <div className="pl-0 lg:pl-7 md:pl-7">
                                <p className="font-semibold text-primary_one mb-3">Order Accuracy Achieved by</p>
                                <div className="flex items-center mb-3">
                                    <div className="pr-2">
                                        <Image
                                            src="/img/icons/ic-accuracy.svg"
                                            alt="Order Accuracy Achieved"
                                            title="Order Accuracy Achieved"
                                            height={40}
                                            width={40}
                                        />
                                    </div>
                                    <p className="fs-xxl font-bold mb-0 text-primary_one">99.4%</p>
                                </div>
                                <p className="fs-md mb-0">
                                    An eCommerce retailer was losing customers due to frequent fulfillment errors. Our custom
                                    order management system automated picking, packing, and tracking, bringing accuracy close to
                                    perfection.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-12">
                        <h2 className="mb-3 text-primary_one">Let&apos;s Build Your Success Story</h2>
                        <p className="mb-3">
                            Your supply chain can do more. Let&apos;s make it faster, leaner, and smarter, together.
                        </p>
                        <div>
                            <Link href="/contact-us" className="btn btn-primary">
                                {'Book a Free Strategy Call'}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default SupplyChainCaseStudies;
